const convertToEmbed = (url) => url.split("&")[0].replace("watch?v=", "embed/");

export default convertToEmbed;
